var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4397 10.6958V1.83273",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69775 15.2727H14.3022",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69782 15.2727C2.07813 15.2727 0.764038 14.0218 0.764038 12.48V10.6958H11.3685V12.48C11.3685 14.0218 12.6825 15.2727 14.3022 15.2727C15.9219 15.2727 17.236 14.0218 17.236 12.48V0.72728C16.5026 0.72728 16.5026 1.86183 15.7589 1.86183C15.0153 1.86183 15.0255 0.72728 14.2819 0.72728C13.5382 0.72728 13.5484 1.86183 12.8048 1.86183C12.0612 1.86183 12.0713 0.72728 11.3277 0.72728C10.5841 0.72728 10.5943 1.86183 9.85063 1.86183C9.10699 1.86183 9.11718 0.72728 8.37355 0.72728C7.62991 0.72728 7.6401 1.86183 6.89647 1.86183C6.15283 1.86183 6.16302 0.72728 5.41939 0.72728V1.83273",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36462 4.93579H14.6677",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6464 7.79639H13.7979",
    stroke: "#B5B7C4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillings);
export default __webpack_public_path__ + "static/media/billings.4b508df87a61410be3aee565fcf3c395.svg";
export { ForwardRef as ReactComponent };